type ToolResult = {
  content: Array<{
    type: 'text'
    text: string
  }>
}

type WebMcpTool = {
  name: string
  title: string
  description: string
  inputSchema: Record<string, unknown>
  annotations: {
    readOnlyHint: boolean
    untrustedContentHint: boolean
  }
  execute: () => Promise<ToolResult>
}

type ModelContext = {
  registerTool: (
    tool: WebMcpTool,
    options?: { signal?: AbortSignal },
  ) => void | Promise<void>
}

type ModelContextHost = {
  modelContext?: ModelContext
}

const modelContext = (navigator as Navigator & ModelContextHost).modelContext
  ?? (document as Document & ModelContextHost).modelContext

if (modelContext?.registerTool) {
  const controller = new AbortController()
  const publicInfoTool: WebMcpTool = {
    name: 'sidewisp_public_info',
    title: 'Get Sidewisp public information',
    description: 'Returns verified public-preview status and machine-readable discovery links for Sidewisp. This tool is read-only and does not claim that unshipped monitoring features are available.',
    inputSchema: {
      type: 'object',
      properties: {},
      additionalProperties: false,
    },
    annotations: {
      readOnlyHint: true,
      untrustedContentHint: false,
    },
    execute: async () => ({
      content: [{
        type: 'text',
        text: JSON.stringify({
          name: 'Sidewisp',
          status: 'private-preview',
          website: 'https://sidewisp.com/',
          productInformation: 'https://sidewisp.com/llms.txt',
          apiCatalog: 'https://sidewisp.com/.well-known/api-catalog',
          openapi: 'https://sidewisp.com/openapi.json',
          waitlist: 'https://sidewisp.com/#waitlist',
          disclosure: 'The public website includes deterministic product demonstrations. Production agent-health adapters and recovery execution are not shipped yet.',
        }),
      }],
    }),
  }

  Promise.resolve(modelContext.registerTool(publicInfoTool, { signal: controller.signal })).catch(() => undefined)
  window.addEventListener('pagehide', () => controller.abort(), { once: true })
}
